package com.evoapps.evoshift.navigation

import androidx.compose.animation.AnimatedContentScope
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.remember
import androidx.navigation.NavBackStackEntry
import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable as navigationComposable
import com.evoapps.evoshift.ui.theme.LocalNavAnimatedVisibilityScope
import com.evoapps.evoshift.ui.theme.LocalSharedTopBarSlot
import com.evoapps.evoshift.ui.theme.SharedTopBarSlot

/**
 * A screen of the app's NavHost: navigation-compose's `composable`, with the screen's own
 * enter/exit scope handed down ([LocalNavAnimatedVisibilityScope]) so its top bar can stay put
 * while the screens change (SH-103, ui/theme/Motion.kt), and a slot that lets only its first
 * bar share ([SharedTopBarSlot]). App.kt imports this one instead.
 */
inline fun <reified T : Any> NavGraphBuilder.composable(
    noinline content: @Composable AnimatedContentScope.(NavBackStackEntry) -> Unit
) {
    navigationComposable<T> { entry ->
        CompositionLocalProvider(
            LocalNavAnimatedVisibilityScope provides this,
            LocalSharedTopBarSlot provides remember { SharedTopBarSlot() }
        ) {
            content(entry)
        }
    }
}
